// accordeon.component.ts
import { Component, OnInit, ChangeDetectionStrategy, inject, input } from "@angular/core";
import {CommonModule} from "@angular/common";
import {GestionService, OrderHistoryObject} from "../../Services/gestion.service";
import {User} from "../../Services/auth.service";
import {ActionButtonComponent} from "../action-button/action-button.component";
import {ModalOrderNotationComponent} from "../Modal/ModalOrderNotation/ModalOrderNotation.component";
import {ModalService} from "../../Services/modal.service";
import {ModalCommandsHistoryComponent} from "../Modal/ModalCommandsHistory/ModalCommandsHistory.component";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: "accordeon",
    templateUrl: "./accordeon.component.html",
    styleUrls: ["./accordeon.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ActionButtonComponent]
})
export class AccordeonComponent implements OnInit {
  private gestion = inject(GestionService);
  private modal = inject(ModalService);
  private toast = inject(ToastrService);

  readonly order = input.required<OrderHistoryObject>();
  readonly isAcceptPayment = input.required<boolean>();
  readonly numberOfDaysForCancelation = input.required<number | undefined>();
  readonly user = input.required<User | undefined>();
  readonly historyWithData = input.required<OrderHistoryObject[]>();
  toggleExpand(): void {
    this.order().isExpanded = !this.order().isExpanded;
  }

  ngOnInit(): void {}

  formatDate(d: string): string {
    let date = new Date(d);

    return date.toLocaleDateString("fr-fr");
  }

  computeStatusState(status: OrderHistoryObject): { classes: string; name: string; icon: string } | null {
    switch (status.status) {
      case "cancelled":
        return {
          classes: "bg-rose-1 text-white",
          name: "Annulée",
          icon: "close"
        }
      case "reimbursed":
        return {
          classes: "bg-orange-1 text-white",
          name: this.isAcceptPayment() ? "Remboursée" : "Annulée",
          icon: "euro"
        }
      case "valid":
        return {
          classes: "bg-vert-1 text-white",
          name: "Validée",
          icon: "check"
        }
    }

    return null;
  }

  getUsername(): string {
    const user = this.user();
    if (!user) return "";

    return user.firstname + " " + user.lastname.toUpperCase();
  }

  isCancellable(history: OrderHistoryObject): boolean {
    const numberOfDaysForCancelation = this.numberOfDaysForCancelation();
    if (history.status !== "valid" || !numberOfDaysForCancelation || numberOfDaysForCancelation <= -1) {
      return false;
    }
    
    const maxDaysForCancellation = numberOfDaysForCancelation;
    if (!maxDaysForCancellation || maxDaysForCancellation === 0) {
      return false;
    }
    
    const deliveryDate = new Date(Date.parse(history.deliveryDate));
    deliveryDate.setHours(0, 0, 0, 0);
    
    const cancelDeadline = new Date(deliveryDate);
    cancelDeadline.setDate(deliveryDate.getDate() - maxDaysForCancellation);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    return today <= cancelDeadline;
  }

  _handler_cancelOrder() {
    const inst: ActionButtonComponent = (this as unknown as ActionButtonComponent);

    inst._state.set("loading");
    inst._displayedLabel.set("Annulation...");

    const id = inst.data().id;

    this.gestion.cancelOrder(id).then(r => {
      if (r.success) {
        inst._state.set("success");
        inst._displayedLabel.set("Commande annulée");

        setTimeout(() => {
          inst.reset();
          this.modal.close()

          this.modal.open(ModalCommandsHistoryComponent, {}, () => {
          });
        }, 2000);
      }
    }).catch(() => {
      inst._state.set("failed");
      inst._displayedLabel.set("Impossible d'annuler");

      setTimeout(() => {
        inst.reset();
      }, 2000);
    });
  }

  _handler_facture() {
    // context's this is an instance of ActionButtonComponent
    const inst: ActionButtonComponent = (this as unknown as ActionButtonComponent);

    inst._state.set("loading");
    inst._displayedLabel.set("Téléchargement...");

    const data = inst.data();
    if (data && typeof data.createdAt === 'string') {
      this.gestion.fetchFacture(data.id).then(r => {
        if (r.success) {
          window.open(r.msg, '_blank');
        } else {
          this.toast.error("Impossible de récupérer la facture", "Erreur", {positionClass: 'toast-top-center'});
        }

        inst._displayedLabel.set(r.success ? "Ouverture..." : "Erreur");
        inst._state.set(r.success ? "success" : "failed");

        setTimeout(() => {
          inst.reset();
        }, 2000);
      })
        .catch(() => {
          inst._displayedLabel.set("Erreur");
          inst._state.set("failed");

          setTimeout(() => {
            inst.reset();
          }, 2000);
        });
    }
  }

  _handler_openNotation(){
    // context's this is an instance of ActionButtonComponent
    const inst: ActionButtonComponent = (this as unknown as ActionButtonComponent);
    

    this.modal.open(ModalOrderNotationComponent, {order: inst.data()}, () => {});

  }
}
